import { ElevatorControlPanelProps } from "../../ElevatorControlPanel";
import { ElevatorStandardButtons } from "./ElevatorStandardButtons";
import { ElevatorStandardFrame } from "./ElevatorStandardFrame/ElevatorStandardFrame";
import { ElevatorStandardHeader } from "./ElevatorStandardHeader";
// eslint-disable-next-line import/order
import { EstateComplexLevel } from "@1games-ru/region-shared/dist/enums/estate/estate";
import { cn } from "@/core/helpers/cn";

export function ElevatorStandard({
  floors,
  targetFloor,
  currentFloor,
  onTargetFloorChange,
  size,
}: ElevatorControlPanelProps) {
  if (size === "md") return null;

  return (
    <ElevatorStandardFrame size={size as "sm" | "lg"}>
      <div className={cn(size === "sm" && "p-[40px]", size === "lg" && "p-[30px]")}>
        <ElevatorStandardHeader
          size={size as "sm" | "lg"}
          currentFloor={currentFloor}
          targetFloor={targetFloor}
        />

        <div className="flex flex-wrap gap-[10px]">
          <ElevatorStandardButtons
            level={EstateComplexLevel.Standard}
            targetFloor={targetFloor}
            currentFloor={currentFloor}
            floors={floors}
            onTargetFloorChange={onTargetFloorChange}
          />
        </div>
      </div>
    </ElevatorStandardFrame>
  );
}
